import { config } from '@shopee-user/platform';
import { ClientId } from '@shopee-user/real-time-metrics-event';

const { BUSINESS_TARGET, LOCALE } = config;

export const METRICS_EVENT_METADATA = {
  client_name: BUSINESS_TARGET,
  client_id: ClientId.ToB,
  locale: LOCALE,
};
